import {
  createBaseThemeOptions,
  createUnifiedTheme,
  palettes,
} from '@backstage/theme';

import {
  aranoxColors,
  aranoxTypography,
} from './tokens';

const commonThemeOptions = {
  fontFamily: aranoxTypography.fontFamily,
  defaultPageTheme: 'home',
};

export const aranoxLightTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.light,
      primary: { main: aranoxColors.brand[700] },
      secondary: { main: aranoxColors.navy[700] },
      success: { main: aranoxColors.semantic.success },
      warning: { main: aranoxColors.semantic.warning },
      error: { main: aranoxColors.semantic.error },
      info: { main: aranoxColors.semantic.info },
      background: {
        default: aranoxColors.neutral[50],
        paper: aranoxColors.neutral[0],
      },
      navigation: {
        background: aranoxColors.navy[950],
        indicator: aranoxColors.brand[300],
        color: aranoxColors.neutral[200],
        selectedColor: aranoxColors.neutral[0],
      },
      banner: {
        info: aranoxColors.semantic.info,
        error: aranoxColors.semantic.error,
        text: aranoxColors.neutral[0],
        link: aranoxColors.brand[100],
      },
      errorBackground: aranoxColors.semantic.error,
      warningBackground: aranoxColors.semantic.warning,
      infoBackground: aranoxColors.semantic.info,
      textContrast: aranoxColors.neutral[0],
    },
  }),
  ...commonThemeOptions,
});

export const aranoxDarkTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.dark,
      primary: { main: aranoxColors.brand[300] },
      secondary: { main: aranoxColors.navy[300] },
      success: { main: '#4fd1a1' },
      warning: { main: '#f0b456' },
      error: { main: '#ef7676' },
      info: { main: '#65afe0' },
      background: {
        default: aranoxColors.neutral[950],
        paper: aranoxColors.neutral[900],
      },
      navigation: {
        background: aranoxColors.navy[950],
        indicator: aranoxColors.brand[300],
        color: aranoxColors.neutral[200],
        selectedColor: aranoxColors.neutral[0],
      },
      banner: {
        info: '#205f87',
        error: '#8f3030',
        text: aranoxColors.neutral[0],
        link: aranoxColors.brand[200],
      },
      errorBackground: '#8f3030',
      warningBackground: '#8a5b16',
      infoBackground: '#205f87',
      textContrast: aranoxColors.neutral[0],
    },
  }),
  ...commonThemeOptions,
});
